import img1 from '../assets/Page6/watch__video-image.png'
import img2 from '../assets/Page6/watch__video-image-w-1.png'
import img3 from '../assets/Page6/watch__video-image-w-2.png'
import img4 from '../assets/Page6/watch__video-image-w.png'
import img5 from '../assets/Page6/watch__video-image-w-3.png'
import img6 from '../assets/Page6/watch__video-image-w-4.png'
import img7 from '../assets/Page6/watch__video-image-w-5.png'
import img8 from '../assets/Page6/watch__video-image-w-6.png'
import img9 from '../assets/Page6/watch__video-image-w-7.png'
import img10 from '../assets/Page6/watch__video-image-w-8.png'
import img11 from '../assets/Page6/watch__video-image-w-9.png'
import img12 from '../assets/Page6/watch__video-image-w-10.png'
import img13 from '../assets/Page6/watch__video-image-w-11.png'
import img14 from '../assets/Page6/watch__video-image-w-12.png'
import img15 from '../assets/Page6/watch__video-image-w-13.png'
import img16 from '../assets/Page6/watch__video-image-w-14.png'
import img17 from '../assets/Page6/watch__video-image-w-15.png'



export const watchData = [
    {
        imgUrl: img1,
        category: 'WATCH',
        text1:"How to play better with your Squad",
        
    },
    {
        imgUrl: img2,
        category: 'WATCH',
        text1:"Check out this fan-made video",
        
    },
    {
        imgUrl: img3,
        category: 'WATCH',
        text1:"Meet an enigmatic new elite",
    },
    {
        imgUrl: img4,
        category: 'WATCH',
        text1:"New Into the Jungle Trailer",
    },
    {
        imgUrl: img5,
        category: 'WATCH',
        text1:"New War in the pacific trailer",
        text2:'#3'
    },
    {
        imgUrl: img6,
        category: 'WATCH',
        text1:"New operation underground video",
    },
    {
        imgUrl: img7,
        category: 'WATCH',
        text1:"Explore Provence and Lofoten",
    },
    {
        imgUrl: img8,
        category: 'A VIOLENT STRUGGLE BEGINS',
        text1:"New to Battlefield v",
    },
    {
        imgUrl: img9,
        category: 'NEWS',
        text1:"Learn About Firestorm Objectives",
    },
    {
        imgUrl: img10,
        category: 'NEWS',
        text1:"Managing inventory in firestorm",
    },
    {
        imgUrl: img11,
        category: 'NEWS',
        text1:"firestorm gadgets and how to get them",
    },
    {
        imgUrl: img12,
        category: 'NEWS',
        text1:"how to get the best weapons in firestorm",
    },
    {
        imgUrl: img13,
        category: 'NEWS',
        text1:"securing combat vehicles in firestorm",
        
    },
    {
        imgUrl: img14,
        category: 'NEWS',
        text1:"playing firestorm solo or in squads",
    },
    {
        imgUrl: img15,
        category: 'NEWS',
        text1:"how headling works in firestorm",
    },
    {
        imgUrl: img16,
        category: 'NEWS',
        text1:"Explore the new halvøy map",
    },
    {
        imgUrl: img17,
        category: 'NEWS',
        text1:"your guide to armor in firestorm",
    },
    
]